export default "__VITE_ASSET__D$W0$jJD__"